var _templateObject;
function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }
import { createStyles } from 'antd-style';
var useStyles = createStyles(function (_ref) {
  var css = _ref.css,
    prefixCls = _ref.prefixCls;
  return {
    progressWrap: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n      display: flex;\n      align-items: center;\n      &.", "-progress-line {\n        margin-inline-end: 0;\n        margin-bottom: 0;\n      }\n      &.", "-progress {\n        line-height: 1;\n      }\n      &.", "-progress .", "-progress-outer {\n        display: flex;\n      }\n    "])), prefixCls, prefixCls, prefixCls, prefixCls)
  };
});
export default useStyles;